import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AddHospital from "../AddHospital";
import HospitalList from "../HospitalList";
import { Link } from "react-router-dom";

const HospitalRegistration = () => {
  // State to track which component is expanded (null, "hospital", or "add")
  const [expandedView, setExpandedView] = useState(null);
    const [dataEdit, setDataEdit] = useState([]);
    const [RefreshApi, setRefreshApi] = useState(false);

  // Toggle function for expanding/collapsing views
  const toggleView = (view) => {
    if (expandedView === view) {
      // If clicking the already expanded view, collapse back to default
      setExpandedView(null);
    } else {
      // Otherwise expand the clicked view
      setExpandedView(view);
    }
  };


  return (
    <>
      <div
        className="d-flex bg-white w-100 p-4 border-bottom justify-content-between align-items-center gap-3"
        style={{ minHeight: 80 }}
      >
        <h4
          className="m-0 flex-grow-1 fw-bold"
          style={{ fontFamily: "sans-serif" }}
        >
          Hospital Registration
        </h4>

        <div className="d-flex gap-3">
          <button
            className={`btn ${
              expandedView === "hospital"
                ? "btn-primary"
                : "btn-outline-primary"
            }`}
            onClick={() => toggleView("hospital")}
          >
            View Hospitals
          </button>
          <button
            className={`btn ${
              expandedView === "add" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => toggleView("add")}
          >
            Add Hospital
          </button>
        </div>
      </div>

      <div className="container-fluid vh-100 d-flex flex-column">
        <div className="p-3 bg-white mt-3 rounded-3">
          <div className="row flex-grow-0">
            {/* AddHospital Component */}
            <div
              className={`col-12 ${
                expandedView === "hospital"
                  ? "d-none"
                  : expandedView === "add"
                  ? "col-12"
                  : "col-lg-5"
              } 
            bg-white d-flex justify-content-center order-lg-2`}
            >
              <AddHospital
                expandedView={expandedView}
                dataEdit={dataEdit}
                setRefreshApi={setRefreshApi}
                RefreshApi={RefreshApi}
              />
            </div>

            {/* HospitalList Component */}
            <div
              className={`col-12 ${
                expandedView === "add"
                  ? "d-none"
                  : expandedView === "hospital"
                  ? "col-12"
                  : "col-lg-7"
              } 
            bg-white d-flex justify-content-center position-relative order-lg-1`}
              style={{
                overflowY: "scroll",
                maxHeight: "95vh",
              }}
            >
              <HospitalList
                RefreshApi={RefreshApi}
                expandedView={expandedView}
                setDataEdit={setDataEdit}
              />

              {/* Partition line (Only visible in default view on md+ screens) */}
              {!expandedView && (
                <div
                  className="d-none d-md-block position-absolute top-0 end-0 h-100"
                  style={{ width: "1px", backgroundColor: "#e0e0e0" }}
                ></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HospitalRegistration;
